import React, { useEffect, useRef, useState } from "react";
import EmployeeCard from "./EmployeeCard";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const Team = () => {
  const carouselRef = useRef(null);
  const carouselWrapperRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  // Employee data array
  const employees = [
    {
      id: 1,
      photo: "Dr.Khalifa Almehrzi _ Chairman and Founder - Nilover Holding.png",
      name: "Dr. Khalifa Almehrzi",
      designation: "Chairman and Founder – Nilover Holding"
    },
    // {
    //   id: 2,
    //   photo: "Fatema Almehrzi_Board Member & CEO – Nilover Holding.png",
    //   name: "Fatema Almehrzi",
    //   designation: "Board Member & CEO – Nilover Holding"
    // },
    {
      id: 3,
      photo: "Ahmed Al Amoudi_Chief Operating Officer - Ghayar Group.png",
      name: "Ahmed Al Amoudi",
      designation: "Chief Operating Officer - Ghayar Group"
    },
    {
      id: 4,
      photo: "Ahmed Al-Shahab_Chief Technology Officer.png",
      name: "Ahmed Al-Shahab",
      designation: "Chief Technology Officer"
    },
    {
      id: 5,
      photo: "Wasi ur rahman_Operations Manager - Ghayar Portal.png",
      name: "Wasi ur Rahman",
      designation: "Operations Manager - Ghayar Portal"
    },
    {
      id: 6,
      photo: "Kalesh Kumar__Senior Accountant.png",
      name: "Kalesh Kumar",
      designation: "Senior Accountant"
    },
    {
      id: 7,
      photo: "Nivya Unnikrishnan_Accounts Executive.png",
      name: "Nivya Unnikrishnan",
      designation: "Accounts Executive"
    },
    {
      id: 8,
      photo: "Anam Riaz_Human Resources Executive.png",
      name: "Anam Riaz",
      designation: "Human Resources Executive"
    },
    {
      id: 9,
      photo: "Mobin Nallari_Multimedia Desinger.png",
      name: "Mobin Nallari",
      designation: "Multimedia Designer"
    },
    // {
    //   id: 9,
    //   photo: "Aysha Ziyana_ Acting Data Management Officer.png",
    //   name: "Aysha Ziyana",
    //   designation: "Acting Data Management Officer"
    // },
    {
      id: 10,
      photo: "Sangita Adikari_Executive Assistant.png",
      name: "Sangita Adikari",
      designation: "Executive Assistant"
    },
    {
      id: 11,
      photo: "Nasir Pathan_FinTech Software Engineer.png",
      name: "Nasir Pathan",
      designation: "FinTech Software Engineer"
    },
    {
      id: 12,
      photo: "Adnan Murtuza  _Full Stack Software Engineer.png",
      name: "Adnan Murtuza",
      designation: "Full Stack Software Engineer"
    },
    {
      id: 13,
      photo: "Abubaker Hussain  _Full Stack Software Engineer.png",
      name: "Abubaker Hussain",
      designation: "Full Stack Software Engineer"
    },
    {
      id: 14,
      photo: "Sayed Yasir_Frontend Software Engineer.png",
      name: "Sayyed Yasir",
      designation: "Frontend Software Engineer"
    },
    {
      id: 15,
      photo: "Kashif Ali__Data Entry Specialist.png",
      name: "Kashif Ali",
      designation: "Data Entry Specialist"
    },
    {
      id: 16,
      photo: "Kaleem Ullah_Data Entry Specialist.png",
      name: "Kaleem Ullah",
      designation: "Data Entry Specialist"
    },
    {
      id: 17,
      photo: "Mahammad Sinan_Data Entry Specialist.png",
      name: "Mahammad Sinan",
      designation: "Data Entry Specialist"
    },
    {
      id: 18,
      photo: "Ali Haider_Data Entry Specialist.png",
      name: "Ali Haider",
      designation: "Data Entry Specialist"
    },
    {
      id: 19,
      photo: "Sumesh K.S_ Procurement Officer.png",
      name: "Sumesh K.S",
      designation: "Procurement Officer"
    },
    {
      id: 20,
      photo: "karishna Das_Purchasing Officer.png",
      name: "Karishna Das",
      designation: "Purchasing Officer"
    },
    // {
    //   id: 21,
    //   photo: "Akhilesh Valappil_Sales Executive.png",
    //   name: "Akhilesh Valappil",
    //   designation: "Sales Executive"
    // },
    {
      id: 30,
      photo: "Mohamed Irfan_Driver.png",
      name: "Mohamed Irfan",
      designation: "Sales Executive"
    },
    {
      id: 22,
      photo: "Abdul Rahim_sales executive.png",
      name: "Abdul Rahim",
      designation: "Sales Executive"
    },
    // {
    //   id: 23,
    //   photo: "Sajad Khan_Sales Executive.png",
    //   name: "Sajad Khan",
    //   designation: "Sales Executive"
    // },
    {
      id: 31,
      photo: "Mohamad Irshad_Driver.png",
      name: "Mohamad Irshad",
      designation: "Sales Executive"
    },
    // {
    //   id: 24,
    //   photo: "Muhammad  Javad_Sales Executive.png",
    //   name: "Muhammad Javad",
    //   designation: "Sales Executive"
    // },
    {
      id: 25,
      photo: "Myla Villejo_Client Relations & Sales Specialist.png",
      name: "Myla Villejo",
      designation: "Client Relations & Sales Specialist"
    },
    {
      id: 26,
      photo: "Nadeem Nazir_Store and Inventory Coordinator.png",
      name: "Nadeem Nazir",
      designation: "Store and Inventory Coordinator"
    },
    {
      id: 27,
      photo: "Fayad Kunhi_Driver.png",
      name: "Fayad Kunhi",
      designation: "Vehicle Operator"
    },
    {
      id: 28,
      photo: "Shenfi Valiyakath_Driver.png",
      name: "Shenfi Valiyakath",
      designation: "Vehicle Operator"
    },
    {
      id: 29,
      photo: "Manu Chandran_Driver.png",
      name: "Manu Chandran",
      designation: "Vehicle Operator"
    },
    // {
    //   id: 30,
    //   photo: "Mohamed Irfan_Driver.png",
    //   name: "Mohamed Irfan",
    //   designation: "Sales Executive"
    // },
    // {
    //   id: 31,
    //   photo: "Mohamad Irshad_Driver.png",
    //   name: "Mohamad Irshad",
    //   designation: "Sales Executive"
    // },
    {
      id: 32,
      photo: "Renjith Kumar_Driver.png",
      name: "Renjith Kumar",
      designation: "Vehicle Operator"
    },
    {
      id: 33,
      photo: "Abdul Saboor_Driver.png",
      name: "Abdul Saboor",
      designation: "Vehicle Operator"
    },
    {
      id: 34,
      photo: "Perne Hanif_Office Attendant.png",
      name: "Perne Hanif",
      designation: "Office Attendant"
    },
    {
      id: 35,
      photo: "Ahmed_Office Attendant.png",
      name: "Ahmed",
      designation: "Office Attendant"
    }
  ];

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1200 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 1200, min: 992 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 992, min: 576 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 576, min: 0 },
      items: 1.3,
    },
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        threshold: 0.3, // 30% visible = start autoplay
      }
    );

    if (carouselWrapperRef.current) {
      observer.observe(carouselWrapperRef.current);
    }

    return () => {
      if (carouselWrapperRef.current) {
        observer.unobserve(carouselWrapperRef.current);
      }
    };
  }, []);

  return (
    <div style={{ background: "#f9f9fb" }} id="People" className="py-5 mt-5">
      <div className="container">
        <div className="team-heading mb-3">
          <h2 className="text-danger">Building On Experience</h2>
          <p>
            Meet the builders and innovators leading the way. At GHAYAR,
            we have a well-seasoned team of experts, each excelling in their
            field and working together to drive the digital transformation
            of the international automotive aftermarket.
          </p>
        </div>
      </div>

      <div className="container position-relative" ref={carouselWrapperRef}>

        <Carousel
          ref={carouselRef}
          responsive={responsive}
          swipeable={false}
          draggable={false}
          autoPlay={isVisible}
          autoPlaySpeed={4000}
          arrows={false}
          infinite={true}
          keyBoardControl
          containerClass="carousel-container"
        >
          {employees.map((employee) => (
            <EmployeeCard
              key={employee.id}
              emp_photo={employee.photo}
              emp_name={employee.name}
              emp_designation={employee.designation}
            />
          ))}
        </Carousel>

        {/* Custom Navigation Buttons (ON slider) */}
        <button
          className="carousel-btn prev-btn"
          onClick={() => carouselRef.current.previous()}
        >
          <i className="ri-arrow-left-s-line"></i>
        </button>

        <button
          className="carousel-btn next-btn"
          onClick={() => carouselRef.current.next()}
        >
          <i className="ri-arrow-right-s-line"></i>
        </button>

      </div>
    </div>
  );
};

export default Team;